const initialState = {
  isLogged: false,
  userData: null,
}

const loggedReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SETLOGGED':
      return {
        ...state,
        isLogged: action.payload.isLogged,
        userData: action.payload.userData,
      }
    default:
      return state
  }
}

export default loggedReducer
